import { useContext } from "react";

import { actions } from "../context/AppProvider";
import appContext from "../context/appContext";
import { useViewport } from "../../../components/ReactContext_Viewport";
import HeSearch from "../../../components/HeSearch/HeSearch";
import HeSelect from "../../../components/HeSelect";

const states = [
    { value: "", label: "Any State" },
    { value: "1000", label: "Alabama" },
    { value: "2000", label: "Alaska" },
    { value: "4000", label: "Arizona" },
    { value: "5000", label: "Arkansas" },
    { value: "6000", label: "California" },
    { value: "8000", label: "Colorado" },
    { value: "9000", label: "Connecticut" },
    { value: "10000", label: "Delaware" },
    { value: "11000", label: "District of Columbia" },
    { value: "12000", label: "Florida" },
    { value: "13000", label: "Georgia" },
    { value: "15000", label: "Hawaii" },
    { value: "16000", label: "Idaho" },
    { value: "17000", label: "Illinois" },
    { value: "18000", label: "Indiana" },
    { value: "19000", label: "Iowa" },
    { value: "20000", label: "Kansas" },
    { value: "21000", label: "Kentucky" },
    { value: "22000", label: "Louisiana" },
    { value: "23000", label: "Maine" },
    { value: "24000", label: "Maryland" },
    { value: "25000", label: "Massachusetts" },
    { value: "26000", label: "Michigan" },
    { value: "27000", label: "Minnesota" },
    { value: "28000", label: "Mississippi" },
    { value: "29000", label: "Missouri" },
    { value: "30000", label: "Montana" },
    { value: "31000", label: "Nebraska" },
    { value: "32000", label: "Nevada" },
    { value: "33000", label: "New Hampshire" },
    { value: "34000", label: "New Jersey" },
    { value: "35000", label: "New Mexico" },
    { value: "36000", label: "New York" },
    { value: "37000", label: "North Carolina" },
    { value: "38000", label: "North Dakota" },
    { value: "39000", label: "Ohio" },
    { value: "40000", label: "Oklahoma" },
    { value: "41000", label: "Oregon" },
    { value: "42000", label: "Pennsylvania" },
    { value: "44000", label: "Rhode Island" },
    { value: "45000", label: "South Carolina" },
    { value: "46000", label: "South Dakota" },
    { value: "47000", label: "Tennessee" },
    { value: "48000", label: "Texas" },
    { value: "49000", label: "Utah" },
    { value: "50000", label: "Vermont" },
    { value: "51000", label: "Virginia" },
    { value: "53000", label: "Washington" },
    { value: "54000", label: "West Virginia" },
    { value: "55000", label: "Wisconsin" },
    { value: "56000", label: "Wyoming" },
];
const Search = ({ onSelect }) => {
    const { screenSize } = useViewport();
    const { state, dispatch } = useContext(appContext);

    const onSearchSelect = (val) => {
        // TODO
        // if (searchTooltipRef) {
        //     searchTooltipRef.tooltipRef = null;
        //     ReactTooltip.hide();
        // }
        dispatch({ type: actions.SET_SEARCH_FEATURE_TO, to: val });
    };
    return (
        <div style={{ position: "relative" }}>
            <div
                style={{
                    position: "absolute",
                    width: "100%",
                    height: 61,
                    zIndex: 2,
                    display: screenSize === "mobile" && !state.isSearchFocusedOnce ? "block" : "none",
                    cursor: "pointer",
                }}
                onClick={() => {
                    dispatch({ type: actions.SET_SEARCH_FOCUSED });
                }}
            ></div>
            <div style={{ position: "relative", zIndex: 1 }}>
                <div
                    style={{
                        color: "black",
                        display: "grid",
                        gridTemplateColumns: "auto " + (screenSize === "mobile" ? "" : "10px 180px"),
                    }}
                >
                    <HeSearch
                        data={state.searchData}
                        placeholder={
                            "Which National Forest" +
                            (state.stateFilter.value === "" ? "?" : " in " + state.stateFilter.label + "?")
                        }
                        onSelect={onSearchSelect}
                        clearOnClick={true}
                        clearOnSelect={true}
                        noResultsMessage={
                            "No results" +
                            (state.stateFilter.value === "" ? "." : " within " + state.stateFilter.label + ".")
                        }
                    />
                    <div style={{ height: 10 }}></div>
                    <HeSelect
                        data={states}
                        selected={state.stateFilter.value}
                        onChange={(newVal) => {
                            dispatch({ type: actions.SET_STATE_FILTER_TO, to: newVal });
                        }}
                    />
                </div>
            </div>
        </div>
    );
};
export default Search;
